import { faPrint } from "@fortawesome/pro-duotone-svg-icons";
import ColorChangingIcon from "../Common/UI/ColorChangingIcon";

function PrintButton({ onClick, name }) {
  return (
    <ColorChangingIcon
      icon={faPrint}
      name={name}
      initialPrimaryColor="#0078D4"
      padding="0 10px 0 0"
      onClick={onClick}
    />
  );
}

export default PrintButton;
